export enum InPlaceEditorParams {
  SourceId = 'sourceId',
  RedirectTo = 'redirectTo'
}
